import { API_G_140_HAISO_IRAI } from '@/constants/api';
import axios from '@/plugins/axios';
import { removeBlankOrNullOrZero } from '@/utils/utils';
import type { Module } from 'vuex';

const g_060: Module<unknown, unknown> = {
  namespaced: true,
  state() {
    return {};
  },
  mutations: {},
  getters: {},
  actions: {
    async getList(_ctx, params) {
      try {
        const res = await axios({
          url: `${API_G_140_HAISO_IRAI}/list`,
          method: 'GET',
          params: removeBlankOrNullOrZero(params),
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getList error.');
        console.log(err);
        return await Promise.reject(err);
      }
    },
    async getDetail(_ctx, params) {
      try {
        const res = await axios({
          url: `${API_G_140_HAISO_IRAI}/detail`,
          method: 'GET',
          params: removeBlankOrNullOrZero(params),
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getDetail error.');
        console.log(err);
        return await Promise.reject(err);
      }
    },
    async putIkkatsu(_ctx, requestData) {
      try {
        const res = await axios({
          url: `${API_G_140_HAISO_IRAI}/ikkatsu`,
          data: {
            requestData,
          },
          method: 'PUT',
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api putIkkatsu error.');
        console.log(err);
      }
    },
    async getCsv(_ctx, payload) {
      try {
        const res = await axios({
          url: `${API_G_140_HAISO_IRAI}/csv`,
          method: 'PUT',
          data: payload,
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getCsv error.');
        console.log(err);
        return await Promise.reject(err);
      }
    },
    async putKakutei(_ctx, payload) {
      try {
        const res = await axios({
          url: `${API_G_140_HAISO_IRAI}/kakutei`,
          method: 'PUT',
          data: payload,
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api putKakutei error.');
        console.log(err);
        return await Promise.reject(err);
      }
    },
    async putShukkoIraisho(_ctx, requestData) {
      try {
        const res = await axios({
          url: `${API_G_140_HAISO_IRAI}/shukkoIraisho`,
          data: requestData,
          method: 'PUT',
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api putShukkoIraisho error.');
        console.log(err);
      }
    },
    async putUnsoSashizusho(_ctx, requestData) {
      try {
        const res = await axios({
          url: `${API_G_140_HAISO_IRAI}/unsoSashizusho`,
          data: requestData,
          method: 'PUT',
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api putUnsoSashizusho error.');
        console.log(err);
      }
    },
  },
};

export default g_060;
